// src/pages/HomeEntry.jsx
import React from "react";
import Home from "./Home";
import OrgPortalHomePage from "./organization/OrgPortalHomePage";
import { useBranding } from "../context/BrandingContext";

export default function HomeEntry() {
    const { isOrgPortal, ready } = useBranding();

    // ✅ Avoid flicker: don't render Home or OrgPortal until we know
    if (!ready) {
        // You can return null, or a tiny loader/skeleton
        return null;
        // or:
        // return <div style={{ minHeight: "100vh", background: "#14151a" }} />;
    }

    if (isOrgPortal) {
        return <OrgPortalHomePage />;
    }

    return <Home />;
}